import { useAppSelector } from 'app-redux/hooks'
import { useShowTagRecsMenu } from 'hooks/showTagRecsMenu'

export const useFloatingMenuOpen = () => {
  const highlightedCards = useAppSelector(state => state.active.highlightedCards)
  const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)
  const [showTagReminderMenu] = useShowTagRecsMenu()

  return !!Object.keys(highlightedCards).length || !!Object.keys(multiSelectedIds).length || showTagReminderMenu
}
